<div class="register__informations">
  <p class="register__informations__title" i18n="@@REGISTER_MODAL.NEEDS_INFORMATIONS_VALIDATION_ACCOUNT">
    We need a few more details from you to validate your account.
  </p>

  <form
    novalidate
    [formGroup]="registerForm"
    [ngClass]="{hasLoader: pending$ | async}"
    id="form-register"
    (ngSubmit)="onSubmit()"
  >
    <div *ngIf="error" class="vc-form__error">{{ error }}</div>

    <!-- PASSWORD -->
    <div *ngIf="!isSocialRegistration" class="vc-form-text register__field">
      <input
        type="password"
        name="password"
        id="user_password"
        class="vc-form-text__input"
        formControlName="password"
        autocomplete="false"
        [attr.type]="displayPassword ? 'text' : 'password'"
      />

      <label class="vc-form-text__label" for="user_password">
        <div *ngIf="password.errors && password.dirty">
          <span *ngIf="password?.errors.required" i18n="@@REGISTER_MODAL.ERROR_REQUIRED_PASSWORD"
            >Password is required</span
          >
        </div>
        <span *ngIf="password.valid || !password.dirty"
          ><ng-container i18n="@@REGISTER_MODAL.PASSWORD">Password</ng-container>*</span
        >
      </label>

      <button
        *ngIf="!displayPassword"
        class="vc-form-text__action"
        (click)="togglePassword()"
        i18n="@@REGISTER_MODAL.SHOW_PASSWORD_INPUT"
      >
        Show
      </button>
      <button
        *ngIf="displayPassword"
        class="vc-form-text__action"
        (click)="togglePassword()"
        i18n="@@REGISTER_MODAL.HIDE_PASSWORD_INPUT"
      >
        Hide
      </button>
    </div>
    <!-- END PASSWORD -->

    <div class="register__nameGenderLine">
      <!-- FIRSTNAME -->
      <div class="register__firstnameInput register__field">
        <div class="vc-form-text">
          <input
            class="vc-form-text__input"
            name="first-name"
            id="first-name"
            type="text"
            required
            formControlName="firstname"
            autocomplete="on"
          />
          <label class="vc-form-text__label" for="first-name">
            <div *ngIf="firstname.errors && firstname.dirty">
              <span *ngIf="firstname.errors.required" i18n="@@REGISTER_MODAL.ERROR_REQUIRED_FIRSTNAME"
                >Firstname is required</span
              >
            </div>
            <span *ngIf="firstname.valid || !firstname.dirty"
              ><ng-container i18n="@@REGISTER_MODAL.FIRSTNAME">Firstname</ng-container>*</span
            >
          </label>
        </div>
      </div>
      <!-- END FIRSTNAME -->

      <!-- GENDER -->
      <div class="register__select register__genderSelect register__field">
        <select formControlName="civility" id="civility" required>
          <option [ngValue]="1" i18n="@@CIVILITY.MR">Mr</option>
          <option [ngValue]="2" i18n="@@CIVILITY.MRS">Mme</option>
        </select>
        <label for="civility">
          <div *ngIf="civility.errors && civility.dirty">
            <span *ngIf="civility.errors.required" i18n="@@REGISTER_MODAL.ERROR_REQUIRED_CIVILITY"
              >Title is a mandatory field</span
            >
          </div>
          <span *ngIf="civility.valid || !civility.dirty"
            ><ng-container i18n="@@REGISTER_MODAL.CIVILITY_SELECT">Gender</ng-container>*</span
          >
        </label>
      </div>
      <!-- END GENDER -->
    </div>

    <!-- COUNTRY -->
    <div class="vc-form-text register__select register__field">
      <select
        aria-label="countries"
        name="country"
        id="country"
        class="i18nChoices__select register__countrySelect"
        formControlName="country"
      >
        <option *ngFor="let c of (countries$ | async)?.countriesShortLists" [ngValue]="c">{{ c.name }} </option>
        <optgroup label="..."></optgroup>
        <option *ngFor="let c of (countries$ | async)?.countriesFullLists" [ngValue]="c">{{ c.name }} </option>
      </select>
      <label class="register__countryLabel" for="country">
        <div *ngIf="country.errors && country.dirty">
          <span *ngIf="country.errors.required" i18n="@@REGISTER_MODAL.ERROR_REQUIRED_COUNTRY"
            >Country is required</span
          >
        </div>
        <span *ngIf="country.valid || !country.dirty"
          ><ng-container i18n="@@REGISTER_MODAL.COUNTRY">Country</ng-container>*</span
        >
      </label>
    </div>
    <!-- END GENDER -->

    <p class="register__requiredFieldMention">
      <ng-container i18n="@@REGISTER_MODAL.MANDATORY_FIELD">* Required field</ng-container>*
    </p>

    <div class="register__cgu">
      <div class="vc-form-checkbox">
        <input
          class="vc-form-checkbox__input"
          name="cgv"
          id="registrationCgv"
          type="checkbox"
          autocomplete="off"
          required
          formControlName="cgv"
        />
        <label
          class="vc-form-checkbox__label"
          for="registrationCgv"
          [ngClass]="{'vc-form-checkbox__label--error': !cgv.pristine && cgv.errors && cgv.errors.required}"
        >
          <ng-container i18n="@@RGPD_REGISTER_MODAL.ACCEPT_LEGAL_CHECKBOX">
            By signing up, I accept Vestiaire Collective's
            <a
              i18n-href="@@RGPD_REGISTER_MODAL.ACCEPT_LEGAL_CHECKBOX.TERM_CONDITION.LINK"
              href="https://us.vestiairecollective.com/cgu2.shtml"
              target="_blank"
              >Terms and Conditions</a
            >
            and
            <a
              i18n-href="@@RGPD_REGISTER_MODAL.ACCEPT_LEGAL_CHECKBOX.PRIVACY_POLICY.LINK"
              href="https://us.vestiairecollective.com/privacy-policy/"
              target="_blank"
              >Privacy Policy</a
            >
          </ng-container>
        </label>
      </div>
    </div>

    <button
      class="vc-btn vc-btn--large vc-btn--full vc-btn--primary"
      type="submit"
      [disabled]="!registerForm.valid"
      i18n="@@REGISTER_MODAL.JOIN_COMMUNITY_BUTTON"
    >
      Join the community
    </button>
  </form>
</div>
